export interface AgentSession {
  id?: string;
  email?: string;
  name?: string;
  isAdmin?: boolean;
  isActive?: boolean;
  isEmailVerified?: boolean;
  token?: string;
  breakerToken?: string;
}

export interface StoredSession {
  token?: string;
  accessToken?: string;
  refreshToken?: string;
  breakerToken?: string;
  agent?: AgentSession;
  data?: {
    token?: string;
    refreshToken?: string;
    breakerToken?: string;
    agent?: AgentSession;
  };
}

const SESSION_KEY = 'loginResponse';

export const readSession = (): StoredSession | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = window.localStorage.getItem(SESSION_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
};

export const getSessionAgent = (): AgentSession | null => {
  const session = readSession();
  return session?.agent ?? session?.data?.agent ?? null;
};

export const getAuthToken = (): string | null => {
  const session = readSession();
  return session?.token ?? session?.accessToken ?? session?.data?.token ?? session?.agent?.token ?? null;
};

export const getRefreshToken = (): string | null => {
  const session = readSession();
  return session?.refreshToken ?? session?.data?.refreshToken ?? null;
};

export const getBreakerToken = (): string | null => {
  const session = readSession();
  return session?.breakerToken ?? session?.data?.breakerToken ?? session?.agent?.breakerToken ?? null;
};

export const requireAuthToken = (): string => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Authentication token missing');
  }

  return token;
};

export const requireBreakerToken = (): string => {
  const token = getBreakerToken();
  if (!token) {
    throw new Error('Breaker token missing');
  }

  return token;
};

export const updateSessionTokens = (token: string, refreshToken?: string): void => {
  const current = readSession() ?? {};
  const next: StoredSession = {
    ...current,
    token,
    accessToken: token,
    refreshToken: refreshToken ?? current.refreshToken ?? current.data?.refreshToken,
    data: {
      ...current.data,
      token,
      refreshToken: refreshToken ?? current.data?.refreshToken,
    },
  };
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(next));
};
